import axios from 'axios';
import React, { useEffect, useState } from 'react';

const Consulta = () => {

    /* const gethorario = async () => {
        try {
            const response = await axios.get (baseURL)
            sethorario(response.data);
        } catch (error) {
            console.error('error al obtener la horario', error)
        }
    } */

    return (

        <div className='seccion'>
            <h1>HORARIOS DE CONSULTA</h1>
            <div class="iframe-container">
            <iframe className='frames' src="https://docs.google.com/spreadsheets/d/e/2PACX-1vS8X8JoTEMT-bqTzmpgmCxaqKCG2YLYGjueI9NAB937Cu_uEHyXfRWvRYR2lRliPA/pubhtml?gid=1603069142&amp;single=true&amp;widget=true&amp;headers=false">
            </iframe>
            </div>
        </div>
    );
}

export default Consulta;
